type LoadingListener = (isLoading: boolean) => void;

class LoadingManager {
  private listeners: LoadingListener[] = [];
  private requestCount = 0;

  addListener(listener: LoadingListener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  private notify(isLoading: boolean) {
    this.listeners.forEach((listener) => listener(isLoading));
  }

  startLoading() {
    this.requestCount++;
    if (this.requestCount === 1) {
      this.notify(true);
    }
  }

  stopLoading() {
    this.requestCount--;
    if (this.requestCount === 0) {
      this.notify(false);
    }
  }
}

export const loadingManager = new LoadingManager();
